import { PromptInput } from "@coffee/ui/components/inputs";
import styled from "@emotion/styled";
import { useChatMessageState } from "../hooks";
import { MessageAuthor } from "../types";

type InputProps = {
  onSubmit: (text: string) => void;
  placeholder?: string;
  className?: string;
};

const Input = ({ placeholder, className, onSubmit }: InputProps) => {
  const { messages } = useChatMessageState();

  const lastBotMessage = [...messages]
    .reverse()
    .find((msg) => msg.author === MessageAuthor.Bot);

  const userCanSendMessage = lastBotMessage?.text !== "" || !lastBotMessage;

  return (
    <PromptInput
      className={className}
      placeholder={placeholder ?? "Type your message here..."}
      onSubmit={onSubmit}
      maxRows={7}
      isDisabled={!userCanSendMessage}
    />
  );
};

export const MessageInput = styled(Input)`
  background-color: ${({ theme }) => theme.colors.component.background[1]};
  border-radius: ${({ theme }) => theme.roundness.md};
  border: 0.0625rem solid ${({ theme }) => theme.colors.component.border[1]};
`;
